import moment from "moment";

export const calculateDateDifference = (date1: Date, date2: Date) => {
    const fecha1 = moment(date1.toISOString().substring(0, 10).concat('T00:00'));
    const fecha2 = moment(date2.toISOString().substring(0, 10).concat('T00:00'));
    // console.log('xxxxxxxxxxxx fecha 1', fecha1, date1, date1.toISOString())
    // console.log('xxxxxxxxxxxx fecha 2', fecha2, date2, date2.toISOString())
    return  fecha2.diff(fecha1, 'days');
};

export function isValidDate(date: any): date is Date {
    return date instanceof Date && !isNaN(date.getTime());
}

export const formatDateString = (date: Date | string | undefined) => {
    let dateAux
    if (date instanceof Date) {
        dateAux = date
    } else if (typeof date === 'string') {
        dateAux = new Date(date.toString().length < 19 ? date.toString().substring(0, 16) : date.toString().substring(0, 19))
    }
    if (dateAux) {
        const day = String(dateAux.getDate()).padStart(2, '0');
        const month = String(dateAux.getMonth() + 1).padStart(2, '0');
        const year = dateAux.getFullYear();
        return `${day}/${month}/${year}`;
    }
    return '-'
}

export const formatDateHoursString = (date: Date | string | undefined) => {
    let dateAux
    if (date instanceof Date) {
        dateAux = date
    } else if (typeof date === 'string') {
        dateAux = new Date(date)
    }
    if (isValidDate(dateAux)) {
        const day = String(dateAux.getDate()).padStart(2, '0');
        const month = String(dateAux.getMonth() + 1).padStart(2, '0');
        const year = dateAux.getFullYear();
        const hours = String(dateAux.getHours()).padStart(2, '0');
        const minutes = String(dateAux.getMinutes()).padStart(2, '0');
        return `${day}/${month}/${year} ${hours}:${minutes}`;
    }
    return '-'
}

export const formatDateHoursString2 = (date: string) => {
    const [datePart, timePart] = date.split(', ');
    const [day, month, year] = datePart.split('/');
    const numericMonth = Number(month);
    const [hours, minutes, seconds] = timePart.split(':');
    const parsedDate = new Date(Number(year), numericMonth - 1, Number(day), Number(hours), Number(minutes), Number(seconds));
    if (parsedDate) {
        const day = String(parsedDate.getDate()).padStart(2, '0');
        const month = String(parsedDate.getMonth() + 1).padStart(2, '0');
        const year = parsedDate.getFullYear();
        const hours = String(parsedDate.getHours()).padStart(2, '0');
        const minutes = String(parsedDate.getMinutes()).padStart(2, '0');
        return `${day}-${month}-${year}-${hours}-${minutes}`;
    }
    return '-'
}

export const formatDateBackendString = (date: Date | undefined) => {
    if (date) {
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${year}/${month}/${day}`;
    }
    return undefined
}

export const currentDateEcuador = (): Date => {
    const now = new Date();
    const timeZone = 'America/Guayaquil';

    const options: Intl.DateTimeFormatOptions = {
        timeZone,
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
    };

    const formatter = new Intl.DateTimeFormat([], options);
    const formattedDate = formatter.format(now);

    return parseFormattedDate(formattedDate);
};

export const currentDateEcuadorFormat = (): String => {
    const now = new Date();
    const timeZone = 'America/Guayaquil';

    const options: Intl.DateTimeFormatOptions = {
        timeZone,
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
    };

    const formatter = new Intl.DateTimeFormat([], options);
    const formattedDate = formatter.format(now);
    return formatDateHoursString2(formattedDate);
};

export const currentDateYearAgo = () => {
    const date = currentDateEcuador()
    date.setFullYear(date.getFullYear() - 1)
    return date
}

const parseFormattedDate = (formattedDate: string): Date => {
    const [day, month, year, time] = formattedDate.split(/[/,]/);
    const [hour, minute, second] = time.split(':');

    return new Date(parseInt(year, 10), parseInt(month, 10) - 1, parseInt(day, 10), parseInt(hour, 10), parseInt(minute, 10), parseInt(second, 10));
};

export function getAgeOfDate(date: Date | string | undefined) {
    if (date) {
        const dateEcuador = currentDateEcuador();
        let dateAux
        if (date instanceof Date) {
            dateAux = date
        } else {
            dateAux = new Date(date)
        }
        let age = dateEcuador.getFullYear() - dateAux.getFullYear();
        const currentMonth = dateEcuador.getMonth() + 1;
        const monthBirthdate = dateAux.getMonth() + 1;
        if (currentMonth < monthBirthdate || (currentMonth === monthBirthdate && dateEcuador.getDate() < dateAux.getDate())) {
            age--;
        }
        return age;
    }
    return '-'
}

export function getDate(date: Date | string | undefined): Date | undefined {
    let dateAux
    if (date instanceof Date) {
        dateAux = date
    } else if (typeof date === 'string' && isValidDate(date)) {
        const [datePart, timePart] = date.split(', ');
        const [day, month, year] = datePart.split('/');
        const numericMonth = Number(month);
        const [hours, minutes, seconds] = timePart.split(':');
        dateAux = new Date(Number(year), numericMonth - 1, Number(day), Number(hours), Number(minutes), Number(seconds));
    }
    return dateAux;
}

/**
 * Función `parseDate`:
 *
 * Esta función formatea en un obj retornando en variables el día, mes, año, hora, minuto.
 *
 * @param {Date} date - La fecha a formatear. Es un objeto.
 * returns {day, month, year, hours, minute}.
 */
function parseDate(date: Date):
    {day: string, month: string, year: string, hours: string, minutes: string, seconds: string} {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear().toString();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    return {
        day, month, year, hours, minutes, seconds
    }
}

/**
 * Función `formatDateHoursString2`:
 *
 * Esta función convierte un string que representa una fecha y hora en el formato `dd/mm/yyyy, hh:mm:ss`
 * a un string con el formato `dd-mm-yyyy-hh-mm`.
 *
 * @param {string} date - El string que contiene la fecha y hora en el formato `dd/mm/yyyy, hh:mm:ss`.
 * returns {string} - La fecha formateada como `dd-mm-yyyy-hh-mm`. Si hay un error en el formato, retorna `'-'`.
 */
export const formatDateHoursStringDoc = (date: Date | string | undefined): string => {
    const dateAux = getDate(date);
    if (isValidDate(dateAux)) {
        if (dateAux) {
            const dateParse = parseDate(dateAux);
            return `${dateParse.year}${dateParse.month}${dateParse.day}${dateParse.hours}${dateParse.minutes}`;
        }
    }
    return '-'
}
